import React, { useEffect, useState, Fragment } from 'react';
const STORAGE_KEY = 'matematicapronta_offer_end';
const DURATION_MS = 24 * 60 * 60 * 1000; // 24h
function getOrCreateEndTime(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const t = parseInt(stored, 10);
      if (!isNaN(t) && t > Date.now()) return t;
    }
  } catch (e) {}
  const end = Date.now() + DURATION_MS;
  try {
    localStorage.setItem(STORAGE_KEY, String(end));
  } catch (e) {}
  return end;
}
function format(n: number) {
  return String(Math.max(0, n)).padStart(2, '0');
}
export function CountdownBanner() {
  const [endTime] = useState(() => getOrCreateEndTime());
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const remaining = Math.max(0, endTime - now);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <div className="border border-badge-red/30 rounded-xl px-3 py-2 sm:px-4 sm:py-3 mb-3 sm:mb-6 flex items-center justify-center gap-2 sm:gap-3 bg-badge-red/5" data-id="element-77">
      <span className="w-1.5 h-1.5 rounded-full bg-badge-red animate-pulse-composited flex-shrink-0" data-id="element-78"></span>
      <p className="text-badge-red font-bold text-[11px] sm:text-sm uppercase tracking-wider whitespace-nowrap" data-id="element-79">
        Scade tra
      </p>
      <div className="flex items-center gap-1 text-text-main font-black text-sm sm:text-base tabular-nums" role="timer" aria-live="polite" data-id="element-80">
        <span data-id="element-81">{format(hours)}</span>
        <span className="text-badge-red" data-id="element-82">:</span>
        <span data-id="element-83">{format(minutes)}</span>
        <span className="text-badge-red" data-id="element-84">:</span>
        <span data-id="element-85">{format(seconds)}</span>
      </div>
    </div>;
}